export const CHPOKIFY_START_SIGN = 'Chpokify | ';
export const CHPOKIFY_END_SIGN = ' | Chpokify';

export enum ONBOARDING_TYPE {
  SPACE = 'space',
  POKER = 'poker'
}
